import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 代理店-独自単価一覧取得
export async function getSaleCompanyUniquePayments(id: string) {
  try {
    const path = "saleCompanyUniquePayments";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
// 代理店-独自単価詳細取得
export async function getSaleCompanyUniquePayment(id: string) {
  try {
    const path = "saleCompanyUniquePayment";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {}
}
// 代理店-独自単価詳細編集
export async function putSaleCompanyUniquePayment(editData: EditDataDifine) {
  try {
    const path = "saleCompanyUniquePayment";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 代理店-独自単価登録
export async function postSaleCompanyUniquePayment(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "saleCompanyUniquePayment";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
